import { mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import programApi from '~/api/program'
import utils from '../utilities'
import trackingApi from '~/api/tracking'
import timezone from 'dayjs/plugin/timezone' // load on demand
import appContainerMixins from "./appContainerMixins"
import accessControl from '~/utilities/accessControl'

dayjs.extend(timezone)


export default {
  mixins: [appContainerMixins],
  computed: {
    ...mapGetters({
      getPersonalList: 'personalProgram/list',
      symposiaFavorites: 'personalProgram/symposiaIdList',
      presentationFavorites: 'personalProgram/presentationIdList',
      speakerFavourites: 'personalProgram/speakerIdList',
      event: 'instancesState/getEvent',
      language: 'instancesState/getLanguage',
      instance: 'instancesState/getInstance',
      isAppContainer: 'instancesState/getIsAppContainer',
      config: 'config/configForKey',
      inVMX: 'instancesState/getInVMX',
      user: 'user/user',
      solr: 'instancesState/getSolrPAG'
    }),
    appConfigV2() {
      const appConfigV2 = this.config('app_config')
      if (appConfigV2.configV2) {
        return appConfigV2.configV2
      }
      return null
    },
    loginStatus() {
      return !!this.user
    },
    sessionTypeLinkConfig() {
      const c = this.config('app_config').configV2.defaultV2
      return c.sessionTypeLink ? c.sessionTypeLink : null
    },
    dateAppConfig() {
      return this.$store.getters['config/configForKey']('app_config')
    },
    myProgramme() {
      if ('Schedule' in this.getPersonalList || 'Result' in this.getPersonalList) {
        const myProgramme = (this.getPersonalList.Schedule || this.getPersonalList.Result.Schedule).filter(
          (item) => item.Type === 'Presentation' || item.Type === 'SessionStart',
        )
        if (myProgramme && myProgramme.length) {
          return myProgramme.sort((a, b) => new Date(a.Start) - new Date(b.Start))
        }
      }
      return null
    },
    sourceContentAction() {
      switch (this.$route.name) {
        case 'PagSearchPage':
          return 'vmx-page-program-search'
        case 'PagFacultyDetailPage':
          return 'vmx-page-program-speaker'
        case 'PagPresentationDetailPage':
          return 'vmx-page-program-presentation'
        case 'PagSessionDetailPage':
          return 'vmx-page-program-session'
        case 'MyAreaPage':
          return 'vmx-page-program-myarea'
        default:
          return 'vmx-page-program'
      }
    },
    resultActionContext() {
      switch (localStorage.getItem('segmentActive')) {
        case 'Programme':
          return 'result-action-session'
        case 'Presentations':
          return 'result-action-presentation'
        case 'Faculty':
          return 'result-action-speaker'
        case 'PosterPresentations':
          return 'result-action-posterpresentation'
        case 'Poster':
          return 'result-action-poster'
        case 'Abstracts':
          return 'result-action-abstract'
        default:
          return null
      }
    },
    disclaimerBoxDefaultExpanded() {
      const c = this.config('app_config').configV2.defaultV2
      return c.disclaimerBoxDefaultExpanded ? c.disclaimerBoxDefaultExpanded : false
    },
  },
  methods: {
    ...mapActions({
      loadSchedule: 'personalProgram/load',
      loadPersonalProgramme: 'personalProgram/load',
      setScheduleFavorite: 'personalProgram/symposiaList',
      addPresentationFavorite: 'personalProgram/presentationList',
      addSpeakerFavourite: 'personalProgram/speakerList',
    }),
    goToNoAccess() {
      const destination = utils.getRouteWithDefaultParams('NoaccessPage')
      const event = new CustomEvent('routerEvent', {
        detail: {
          message: 'rerouteParent',
          destination,
        },
      })
      window.dispatchEvent(event)
    },
    contactSpeaker(speaker) {
      this.speaker = speaker
      this.showContactFormModal = true
      this.contactFormInitialized = true
    },
    formatDateTime(value) {
      const programConfig = this.dateAppConfig.config[0].programme[0]
      const eventTimezone = utils.eventTimezone()
  
      if (programConfig.dateformat && value) {
          if (this.solr) {
              return `${dayjs(value).format(programConfig.dateformat)}`
          } else {
              if (eventTimezone === utils.selectedTimezone()) {
                  return `${dayjs(value).format(programConfig.dateformat)}`
              }
              return `${dayjs(dayjs(value).tz(eventTimezone, true)).tz(utils.selectedTimezone()).format(programConfig.dateformat)}`
          }
      }
      if (value && !programConfig.dateformat) {
          if (this.solr) {
              return `${dayjs(value).format('dddd, DD MMM YYYY')}`
          } else {
              if (eventTimezone === utils.selectedTimezone()) {
                  return `${dayjs(value).format('dddd, DD MMM YYYY')}`
              }
              return `${dayjs(dayjs(value).tz(eventTimezone, true)).tz(utils.selectedTimezone()).format('dddd, DD MMM YYYY')}`
          }
      }
      return null
    },
  
    async trackFilter(entityId, sourceContext) {
      trackingApi.trackCustomAction(this.sourceContentAction, entityId, sourceContext)
    },
    convertTimeToTz(time) {
      return dayjs(dayjs.tz(time, utils.eventTimezone())).tz(dayjs.tz.guess()).format('YYYY-MM-DDTHH:mm:ss')

    },
    downloadCal(id, type, isPoster, item) {
      const newItem = {
        ...item,
        Text: item.Text,
        RoomName: item.RoomName,
        StartDateTime: this.convertTimeToTz(item.StartDateTime),
        EndDateTime: this.convertTimeToTz(item.EndDateTime)
      }
      if(this.isAppContainer){
        const message = 'cal-download'
        const messageObj = {
          message: message,
          content: newItem
        }
        const stringifiedMessageObj = JSON.stringify(messageObj)
        if(window.webkit && window.webkit.messageHandlers){
          window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj)
        }
        if (type === 'Presentation') {
          this.trackFilter(id, isPoster ? 'poster-ics-dl' : 'presentation-ics-dl')
        }
        if (type === 'Session') {   
          this.trackFilter(id, isPoster ? 'poster-session-ics-dl' : 'session-ics-dl')    
        }
      }
      else {
        if (type === 'Presentation') {
          this.trackFilter(id, isPoster ? 'poster-ics-dl' : 'presentation-ics-dl')
          programApi.downloadOutlookPresentation(id)
        }
        if (type === 'SessionStart') {
          this.trackFilter(id, isPoster ? 'poster-session-ics-dl' : 'session-ics-dl')
          programApi.downloadOutlookSession(id)
        }
      }
    },
    async downloadAbstract(url, id) {
      trackingApi.trackCustomAction('vmx-page-program', id, 'search-abstract')

      if(this.solr && (url === undefined || url === null) && !!id) {
        const abstractData = await programApi.getAbstractSolr(id)
        if (this.isAppContainer) {
           this.openPdf(abstractData.path)
        } else {
          window.open(abstractData.path, '_blank')
        }
        return 
      }

      if (this.isAppContainer) {
        if (window.location.href.indexOf('espghan') > -1 || window.location.href.indexOf('eha2022') > -1) {
          window.location.assign(`${this.appConfigV2.defaultV2.abstractS3Url}${encodeURIComponent(url)}`)
        } else {
         this.openPdf(url)
        }
      } else {
        window.open(url, '_blank')
      }
    },
    abstractIframeUrl(url) {
      this.$router.push(utils.getRouteWithDefaultParams('PagAbstractPage', { abstracturl: url }, {}))
    },
    formatTime(start, end) {
      const programConfig = this.dateAppConfig.config[0].programme[0]
      const eventTimezone = utils.eventTimezone()
  
      if (programConfig.dateformatTime && start && end) {
          if (this.solr) {
              return `${dayjs(start).format(programConfig.dateformatTime)} - ${dayjs(end).format(programConfig.dateformatTime)}`
          } else {
              if (eventTimezone === utils.selectedTimezone()) {
                  return `${dayjs(start).format(programConfig.dateformatTime)} - ${dayjs(end).format(programConfig.dateformatTime)}`
              }
              return `${dayjs(dayjs(start).tz(eventTimezone, true)).tz(utils.selectedTimezone()).format(programConfig.dateformatTime)} - ${dayjs(dayjs(end).tz(eventTimezone, true)).tz(utils.selectedTimezone()).format(programConfig.dateformatTime)}`
          }
      }
      if (start && end && !programConfig.dateformatTime) {
          if (this.solr) {
              return `${dayjs(start).format(utils.timeFormat())} - ${dayjs(end).format(utils.timeFormat())}`
          } else {
              if (eventTimezone === utils.selectedTimezone()) {
                  return `${dayjs(start).format(utils.timeFormat())} - ${dayjs(end).format(utils.timeFormat())}`
              }
              return `${dayjs(dayjs(start).tz(eventTimezone, true)).tz(utils.selectedTimezone()).format(utils.timeFormat())} - ${dayjs(dayjs(end).tz(eventTimezone, true)).tz(utils.selectedTimezone()).format(utils.timeFormat())}`
          }
      }
      return null
    },
    formatTimeValue(value) {
      const programConfig = this.dateAppConfig.config[0].programme[0]
      const eventTimezone = utils.eventTimezone()
      if (programConfig.dateformatTime && value) {
          if (this.solr) {
              return `${dayjs(value).format(programConfig.dateformatTime)}`
          } else {
              if (eventTimezone === utils.selectedTimezone()) {
                  return `${dayjs(value).format(programConfig.dateformatTime)}`
              }
              return `${dayjs(value).tz(eventTimezone, true).tz(utils.selectedTimezone()).format(programConfig.dateformatTime)}`
          }
      }
      if (value && !programConfig.dateformatTime) {
          if (this.solr) {
              return `${dayjs(value).format(utils.timeFormat())}`
          } else {
              if (eventTimezone === utils.selectedTimezone()) {
                  return `${dayjs(value).format(utils.timeFormat())}`
              }
              return `${dayjs(value).tz(eventTimezone, true).tz(utils.selectedTimezone()).format(utils.timeFormat())}`
          }
      }
      return null
    },  
    formatTimeSession(start, end) {
      const programConfig = this.dateAppConfig.config[0].programme[0]

      if (programConfig.dateformatTime && start && end) {
        return `${dayjs(dayjs(start)).format(programConfig.dateformatTime)} - ${dayjs(dayjs(end)).format(programConfig.dateformatTime)}`
      }
      if (start && end && !programConfig.dateformatTime) {
        return `${dayjs(dayjs(start)).format(utils.timeFormat())} - ${dayjs(dayjs(end)).format(utils.timeFormat())}`
      }
      return null
    },
    async toggleFavorites(id, type, isPoster) {
      if (type === 'Presentation') {
        if (this.presentationFavorites) {
          if (this.presentationFavorites.some((item) => item === id)) {
            this.trackFilter(id, isPoster ? 'poster-remove-fav' : 'presentation-remove-fav')
            programApi.removePresentationFavourite(id).then(() => {
              this.loadSchedule({ loadScheduleNew: true })
            })
          } else {
            this.trackFilter(id, isPoster ? 'poster-add-fav' : 'presentation-add-fav')
            this.addPresentationFavorite(id)
            programApi.addPresentationFavourite(id).then(() => {
              this.loadSchedule({ loadScheduleNew: true })
            })
          }
        }
      } else if (type === 'SessionStart') {
        if (this.symposiaFavorites) {
          if (this.symposiaFavorites.some((item) => item === id)) {
            this.trackFilter(id, isPoster ? 'poster-session-remove-fav' : 'session-remove-fav')
            programApi.removeSessionFavorite(id).then(() => {
              this.loadSchedule({ loadScheduleNew: true })
            })
          } else {
            this.trackFilter(id, isPoster ? 'poster-session-add-fav' : 'session-add-fav')
            this.setScheduleFavorite(id)
            programApi.addSessionFavorite(id).then(() => {
              this.loadSchedule({ loadScheduleNew: true })
            })
          }
        }
      } else if (type === 'Author') {
        if (this.speakerFavourites) {
          if (this.speakerFavourites.some((item) => item === id)) {
            this.trackFilter(id, 'speaker-remove-fav')
            programApi.removeSpeakerFavourite(id, type).then(() => {
              this.loadSchedule({ loadScheduleNew: true })
            })
          } else {
            this.trackFilter(id, 'speaker-add-fav')
            this.addSpeakerFavourite(id)
            programApi.addSpeakerFavourite(type).then(() => {
              this.loadSchedule({ loadScheduleNew: true })
            })
          }
        }
      }
    },
    isFavorite(id, type) {
      if (type === 'Presentation') {
        return this.presentationFavorites.length > 0 ? this.presentationFavorites.some((item) => item === id) : false
      }
      if (type === 'SessionStart') {
        return this.symposiaFavorites.length > 0 ? this.symposiaFavorites.some((item) => item === id) : false
      }
      if (type === 'Author') {
        return this.speakerFavourites.length > 0 ? this.speakerFavourites.some((item) => item === id) : false
      }
      return false
    },

    sendLoginEvent(page) {
      if(localStorage.getItem('layer') !== 'Standalone' && localStorage.getItem('layer') !== 'Manage' ) {
        if('disableAuthForPages' in this.dateAppConfig.config[0].defaults && !this.dateAppConfig.config[0].defaults.disableAuthForPages.includes(page)) {
          const event = new CustomEvent('pagesForPagAuth', {
            detail: {
              message: 'pagesForPagAuth',
            },
          })
          window.dispatchEvent(event)
        }

      }
    },
    async goToProgramme(id, type, session, presentation) {

      const showAccessDeniedModal = this.dateAppConfig.config[0].defaults.showNoAccessModal || false
      let hasAccess = true
      if('forceAuthForPagPages' in this.dateAppConfig.config[0].defaults ){
        if( ((type === 'SessionStart' && this.dateAppConfig.config[0].defaults.forceAuthForPagPages.includes('PagSessionDetailPage')) || (type ==='Presentation' && this.dateAppConfig.config[0].defaults.forceAuthForPagPages.includes('PagPresentationDetailPage')))
        && this.dateAppConfig.config[0].defaults.externalAuth.loginUrl 
        && (this.inVMX || this.isAppContainer)
        && !this.loginStatus) {

          let returnUrl = `${window.location.origin}/${this.instance}/${this.event}/${this.language}/${type === 'SessionStart' ? 'session' : 'presentation'}/${id}`
          const loginUrl = this.dateAppConfig.config[0].defaults.externalAuth.loginUrl;
          const loginUrlWithReturn = returnUrl ? `${loginUrl}?returnUrl=${encodeURIComponent(returnUrl)}` : loginUrl;

          window.open(loginUrlWithReturn, '_self');
          return
        }
      }

      if((presentation && presentation.SessionId) || (session && session.SessionId)) {
        hasAccess = await accessControl.accessControlSession(type === "Presentation" ? presentation.SessionId.toString() : session.SessionId.toString())
      }

      if (!hasAccess && this.inVMX) { 
        this.goToNoAccess()
        return
      }

      if(!hasAccess && showAccessDeniedModal) { 
        this.$root.$emit('noaccess', hasAccess)
        return
      } else if (this.appConfigV2 && this.appConfigV2.defaultV2.routeV2) {
        switch (type) {
          case 'Presentation':
            this.trackFilter(id, this.resultActionContext ? this.resultActionContext : type)
            // this.sendLoginEvent('PagPresentationDetailPage')
            this.$router.push(utils.getRouteWithDefaultParams('PagPresentationDetailPage', { presentationId: id }, {}))
            break
          case 'SessionStart':
            this.trackFilter(id, this.resultActionContext ? this.resultActionContext : type)
            if (this.sessionLabel && !this.$route.query.name) {
              let shouldSkip

              this.sessionLabel.forEach((setting) => {
                if (shouldSkip) {
                  return
                }
                if (setting.redirect) {
                  const newQuery = setting.redirect.query || {}
                  newQuery.day = session.StartDateTime.substring(0, 10)
                  switch (setting.Identifier) {
                    case 'SessionType':
                    {
                      if (setting.includes.some((stype) => stype === session.SessionTypeName)) {
                        this.$router.push(utils.getRouteWithDefaultParams(setting.redirect.name, setting.redirect.params, setting.redirect.query))
                        shouldSkip = true
                      } else {
                        // this.sendLoginEvent('PagSessionDetailPage')
                        this.$router.push(utils.getRouteWithDefaultParams('PagSessionDetailPage', { sessionId: id }, {}))
                        shouldSkip = true
                      }
                      return
                    }
                    case 'SessionId':
                    {
                      if (setting.includes.some((sid) => sid === session.SessionId)) {
                        this.$router.push(utils.getRouteWithDefaultParams(setting.redirect.name, setting.redirect.params, setting.redirect.query))
                        shouldSkip = true
                      } else {
                        // this.sendLoginEvent('PagSessionDetailPage')
                        this.$router.push(utils.getRouteWithDefaultParams('PagSessionDetailPage', { sessionId: id }, {}))
                        shouldSkip = true
                      }
                      return
                    }
                    default:
                      // this.sendLoginEvent('PagSessionDetailPage')
                      this.$router.push(utils.getRouteWithDefaultParams('PagSessionDetailPage', { sessionId: id }, {}))
                  }
                } else {
                  // this.sendLoginEvent('PagSessionDetailPage')
                  this.$router.push(utils.getRouteWithDefaultParams('PagSessionDetailPage', { sessionId: id }, {}))
                }
              })
            } if (this.sessionTypeLinkConfig && session.SessionTypeName in this.sessionTypeLinkConfig) {

              const { link, target } = this.sessionTypeLinkConfig[session.SessionTypeName]
        
              if (utils.isUrl(link)) {
        
                window.open(link, target)
              } else if (utils.isObject(link)) {
                if (this.$route.name === link.name) {
                  // this.sendLoginEvent('PagSessionDetailPage')
                  this.$router.push(utils.getRouteWithDefaultParams('PagSessionDetailPage', { sessionId: id }, {}))
                  return
                }
                this.$router.push(utils.getRouteWithDefaultParams(link.name, link.params, link.query))
              }
            } else {
              // this.sendLoginEvent('PagSessionDetailPage')
              this.$router.push(utils.getRouteWithDefaultParams('PagSessionDetailPage', { sessionId: id }, {}))
            }
            break
          default:
            this.trackFilter(id, this.resultActionContext ? this.resultActionContext : type)
            // this.sendLoginEvent('PagFacultyDetailPage')
            this.$router.push(utils.getRouteWithDefaultParams('PagFacultyDetailPage', { userId: id }, {}))
            break
        }
      } else {
        switch (type) {
          case 'Presentation':
            this.$router.push(utils.getRouteWithDefaultParams('ProgramPage', {}, { presentation: id }))
            break
          case 'SessionStart':
            this.$router.push(utils.getRouteWithDefaultParams('ProgramPage', {}, { session: id }))
            break
          default:
            this.$router.push(utils.getRouteWithDefaultParams('ProgramPage', {}, { userId: id }))
            break
        }
      }
    },
  },
}
